// Hamburger menu
let hamburger = document.querySelector('.hamburger');
let menu = document.querySelector('.list__btn');

function showMenu () {
  hamburger.classList.toggle('hamburger__active');
  menu.classList.toggle('list__btn--active');
}

// Copyright
let date = new Date();
document.querySelector('.footer__copyright p span').textContent = date.getFullYear();

// WOW Animation
let wow = new WOW(
    {
      boxClass:     'wow',
      animateClass: 'animate__animated',
      mobile: false
    }
);
wow.init();

//Video youtube
function r(f) {
  /in/.test(document.readyState) ? setTimeout('r(' + f + ')', 9) : f()
}

r(function () {
  if (!document.getElementsByClassName) {
    // Поддержка IE8
    var getElementsByClassName = function (node, classname) {
      var a = [];
      var re = new RegExp('(^| )' + classname + '( |$)');
      var els = node.getElementsByTagName("*");
      for (var i = 0, j = els.length; i < j; i++)
        if (re.test(els[i].className)) a.push(els[i]);
      return a;
    }
    var videos = getElementsByClassName(document.body, "youtube");
  } else {
    var videos = document.getElementsByClassName("youtube");
  }

  var nb_videos = videos.length;
  for (var i = 0; i < nb_videos; i++) {
    // Находим постер для видео, зная ID нашего видео
    videos[i].style.backgroundImage = 'url(http://img.youtube.com/vi/' + videos[i].id + '/maxresdefault.jpg)';

    // Размещаем над постером кнопку Play, чтобы создать эффект плеера
    let play = document.querySelector('.about_brand__video--play');
    videos[i].appendChild(play);

    videos[i].onclick = function () {
      // Создаем iFrame и сразу начинаем проигрывать видео, т.е. атрибут autoplay у видео в значении 1
      var iframe = document.createElement("iframe");
      var iframe_url = "https://www.youtube.com/embed/" + this.id + "?autoplay=1&autohide=1";
      if (this.getAttribute("data-params")) iframe_url += '&' + this.getAttribute("data-params");
      iframe.setAttribute("src", iframe_url);
      iframe.setAttribute("class", 'youtube');
      iframe.setAttribute("frameborder", '0');
      iframe.setAttribute("allowfullscreen", '');
      iframe.setAttribute("allow", 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');

      // Заменяем начальное изображение (постер) на iFrame
      this.parentNode.replaceChild(iframe, this);
    }
  }
});


// Функция для плавного скролла с динамическим header
const smoothScroll = (selector, headerSelector = null, extraOffset = 0) => {
  const target = document.querySelector(selector);
  if (!target) return;

  let headerOffset = 0;
  if (headerSelector) {
    const header = document.querySelector(headerSelector);
    if (header) {
      headerOffset = header.getBoundingClientRect().height;
    }
  }

  const elementPosition = target.getBoundingClientRect().top + window.scrollY;
  const offsetPosition = elementPosition - headerOffset - extraOffset;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  });
};

// Привязка ко всем ссылкам
document.querySelectorAll('a[href*="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    const href = this.getAttribute('href');
    const url = new URL(href, window.location.origin);
    const hash = url.hash; // #section2
    const pathname = url.pathname;

    if (pathname === window.location.pathname) {
      // Если на той же странице
      if (hash) {
        e.preventDefault();
        smoothScroll(hash, '.header', 10);
      }
    } else {
      // Если на другой странице — разрешаем стандартный переход
      // Но сохраняем хэш в sessionStorage, чтобы после загрузки страницы прокрутить
      if (hash) {
        sessionStorage.setItem('scrollToHash', hash);
      }
    }
  });
});

// После загрузки страницы проверяем, нужно ли скроллить
window.addEventListener('DOMContentLoaded', () => {
  const hash = sessionStorage.getItem('scrollToHash');
  if (hash) {
    sessionStorage.removeItem('scrollToHash');
    smoothScroll(hash, '.header', 10);
  }
});


if (window.innerWidth <= 768) {
  let titleSVG = document.querySelector('.title .pc');
  if (titleSVG) {
    titleSVG.remove();
  }
}
